export default {"src":"/_next/static/media/materialui.2900e517.svg","height":204,"width":256,"blurWidth":0,"blurHeight":0};